import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import URI from 'urijs';
import store from './store';
import WidgetContainer from './containers/WidgetContainer';
import { fetchWidgetConfiguration, widgetConfiguration } from './reducers/widgetReducer';

require('../assets/styles/widget/bundle.less');

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

function renderApp() {
  ReactDOM.render(<WidgetContainer store={store} />, document.querySelector('#widget-app'));
}

const url = new URI(window.location.href);
const queryParams = url && url.search(true);
const { channelId, webFormId } = queryParams;
fetchWidgetConfiguration(webFormId, channelId).then((response) => {
  if (response.length) {
    store.dispatch(widgetConfiguration(response[0]));
    renderApp();
  } else {
    // TODO Will see what style changes are required when widget is disabled
  }
});
